import { useTranslation } from "react-i18next";
import { Grid } from "@mantine/core";
import { Company } from "@/types";
import { useGetOutstandingInvoicesForCompany, useGetOutstandingPaymentsForCompany } from "@/services/Accounting";

import Text from "@/components/atoms/Text";
import NumberFormatter from "@/components/atoms/NumberFormatter";

interface EconomyTabProps {
  company: Company;
}

export default function EconomyTab({ company }: EconomyTabProps) {
  const { t } = useTranslation();

  const { data: paymentsData } = useGetOutstandingPaymentsForCompany(company.id);
  const { data: invoicesData } = useGetOutstandingInvoicesForCompany(company.id);

  return (
    <>
      <Grid p="lg">
        <Grid.Col span={4}>
          <Text color="secondary" size="sm">
            {t("commonAdmin:outstandingAmount")}
          </Text>
        </Grid.Col>
        <Grid.Col span={8}>
          <Text size="sm">
            {paymentsData && (
              <NumberFormatter value={paymentsData.totalAmount} suffix={` ${paymentsData.currencyType}`} />
            )}
          </Text>
        </Grid.Col>

        <Grid.Col span={4}>
          <Text color="secondary" size="sm">
            {t("commonAdmin:outstandingInvoices")}
          </Text>
        </Grid.Col>
        <Grid.Col span={8}>
          <Text size="sm">
            {invoicesData && (
              <NumberFormatter value={invoicesData.totalAmountOutstanding} suffix={` ${invoicesData.currencyType}`} />
            )}
          </Text>
        </Grid.Col>

        <Grid.Col span={4}>
          <Text color="secondary" size="sm">
            {t("commonAdmin:customerReceivables")}
          </Text>
        </Grid.Col>
        <Grid.Col span={8}>
          <Text size="sm">{}</Text>
        </Grid.Col>
      </Grid>
    </>
  );
}
